import useNotification from "./useNotification"

const hooks = {
    useNotification
}
export default hooks